/* eslint-disable react-hooks/exhaustive-deps */
//#region Libraries
import { useEffect, useState } from "react";
import { 
    Routes, 
    Route, 
    Navigate,
    useNavigate
} from "react-router-dom";
//#endregion
//#region Components
import Sidebar from "views/components/Sidebar/Sidebar";
import Header from "views/components/Header/Header";
import Main from "components/Main/Main";
//#endregion
//#region Views
import Home from "views/Home/Home";
import Overlay from "views/components/Header/components/Profile/components/Logout/Overlay/Overlay";
//#endregion
import { currentUserLocalStorage } from "services/storage/general";
import { getToken, clearAllStorage } from "services/auth/tokenAuth";
//#region Services
import { IS_PRODUCTION } from "config/deploymentMode";
import useOpenLogoutOptions from "./utils/useOpenLogoutOptions";
import ABSOLUTE_PATHS from "./utils/absolutePaths";
import { getRoutes } from "./utils/helpers";
import DashboardContext from "./utils/context/DashboardContext";
import { INIT_USER_DASHBOARD_CONTEXT } from "./utils/context/constants";
import { isResourceCoordinatorByCampus } from "config/userPermissions";
import { requestGetCampusByResourceUser } from "services/resources/relatedToResources";
//#endregion

const Dashboard = () => {
    const navigate = useNavigate();
    //#region States
    const [user, setUser] = useState({ ...INIT_USER_DASHBOARD_CONTEXT });
    const [userCampusId, setUserCampusId] = useState(0);
    const [modulesOfCurrentUser, setModulesOfCurrentUser] = useState([]);
    const [routes, setRoutes] = useState(null);
    //#endregion
    const openLogoutOptions = useOpenLogoutOptions(true);
    //#region Effects
    useEffect(() => {
        try { 
            validatePermissions(); 
        }
        catch (err) {
            clearAllStorage();
            navigate(ABSOLUTE_PATHS.LOGIN);
        }
    }, []);
    useEffect(() => {
        fillRoutesAccordsPermissions();
    }, [modulesOfCurrentUser]);
    //#endregion
    //#region Functions
    const validatePermissions = () => {
        //#region Validando previo logueo
        if (!getToken()) {
            navigate(ABSOLUTE_PATHS.LOGIN);
            return;
        }
        const currentUser = currentUserLocalStorage.get();
        if (!currentUser || typeof currentUser.role !== "object") {
            clearAllStorage();
            navigate(IS_PRODUCTION 
                ? ABSOLUTE_PATHS.LOGIN 
                : ABSOLUTE_PATHS.USERS_PER_ROLE);
            return;
        }
        //#endregion
        const { modules } = currentUser;
        setModulesOfCurrentUser(modules.map(({ id }) => id));
        if (isResourceCoordinatorByCampus(currentUser.role.id)) 
            fillUserCampusId();
        setUser({
            id: currentUser.id,
            name: currentUser.name,
            role: currentUser.role
        });
    }
    async function fillUserCampusId() {
        const campusId = await requestGetCampusByResourceUser();
        setUserCampusId(campusId);
    }
    const fillRoutesAccordsPermissions = () => {
        if (modulesOfCurrentUser.length === 0)
            return;
        setRoutes(getRoutes(modulesOfCurrentUser));
    }
    //#endregion
    if (routes === null)
        return null;
    return (
        <DashboardContext.Provider value={{
            user,
            userCampusId
        }}>
            <Overlay openLogoutOptions={openLogoutOptions}/>
            <Sidebar moduleIdsViewsOfCurrentUser={modulesOfCurrentUser}/>
            <Header openLogoutOptions={openLogoutOptions}/>
            <Main>
                <Routes>
                    <Route path="home"
                        element={
                            <Home moduleIdsViewsOfCurrentUser={modulesOfCurrentUser}/>}/>
                    {routes}
                    {routes !== null && (
                        <Route 
                            path="*" 
                            element={<Navigate to={ABSOLUTE_PATHS.HOME} replace/>}/>
                    )}
                </Routes>
            </Main>
        </DashboardContext.Provider>
    )
}

export default Dashboard;